import { useState } from 'react';
import { api, ErroApi } from '../api';
import { LogoOrbita, OrbitaAberta } from '../orbita';
import { useAgir } from '../../../compartilhado/useAgir';

/**
 * A porta do app: telefone → código de 6 dígitos pelo WhatsApp → dentro.
 *
 * É a "ativação" da §5.2 — entrar pela primeira vez tira a conta de
 * `pendente` e libera o resgate. O mockup não desenhou esta tela; ela fala a
 * mesma língua dele: órbita, Satoshi, um passo por vez.
 */
export function Entrada({ aoEntrar, aviso }: { aoEntrar: () => void; aviso?: string }) {
  const [passo, setPasso] = useState<'telefone' | 'codigo'>('telefone');
  const [telefone, setTelefone] = useState('');
  const [codigo, setCodigo] = useState('');
  /* O aviso de fora é o QR do balcão que falhou (vencido, já usado) —
   * a pessoa cai aqui com a explicação, não numa tela muda. */
  const [erro, setErro] = useState(aviso ?? '');
  /*
   * Os dois passos dividem a MESMA chave de propósito: são exclusivos na tela,
   * e cada um dispara um WhatsApp ou consome o código de uma vez. O `useState`
   * que segurava isto só vira `disabled` no quadro seguinte — dois toques no
   * mesmo quadro mandavam duas mensagens.
   */
  const { ocupado, agir } = useAgir();

  async function pedirCodigo() {
    await agir(async () => {
      setErro('');
      try {
        await api.entrar(telefone);
        setPasso('codigo');
      } catch (e) {
        setErro(e instanceof ErroApi ? e.message : 'não consegui enviar o código');
      }
    });
  }

  async function confirmar() {
    await agir(async () => {
      setErro('');
      try {
        await api.codigo(telefone, codigo);
        aoEntrar();
      } catch (e) {
        setErro(e instanceof ErroApi ? e.message : 'código errado ou vencido');
      }
    });
  }

  return (
    <div className="entrada">
      <div className="en-topo">
        <LogoOrbita tamanho={34} />
      </div>
      <OrbitaAberta frac={0.62} />
      {passo === 'telefone' ? (
        <>
          <h1 className="en-titulo">suas moedas moram aqui</h1>
          <p className="en-sub">entre com o telefone que você usa no caixa</p>
          <input
            className="en-campo"
            type="tel"
            inputMode="tel"
            placeholder="(19) 99999-9999"
            value={telefone}
            onChange={(e) => setTelefone(e.target.value)}
            autoFocus
          />
          {erro && <div className="en-erro">{erro}</div>}
          <button className="botao-cheio" disabled={ocupado || !telefone.trim()} onClick={() => void pedirCodigo()}>
            {ocupado ? 'Enviando…' : 'Receber código no WhatsApp'}
          </button>
        </>
      ) : (
        <>
          <h1 className="en-titulo">olha o WhatsApp</h1>
          <p className="en-sub">mandamos um código de 6 dígitos para {telefone}</p>
          <input
            className="en-campo en-codigo"
            type="text"
            inputMode="numeric"
            maxLength={6}
            placeholder="······"
            value={codigo}
            onChange={(e) => setCodigo(e.target.value.replace(/\D/g, ''))}
            autoFocus
          />
          {erro && <div className="en-erro">{erro}</div>}
          <button className="botao-cheio" disabled={ocupado || codigo.length !== 6} onClick={() => void confirmar()}>
            {ocupado ? 'Conferindo…' : 'Entrar'}
          </button>
          <button className="en-voltar" disabled={ocupado} onClick={() => setPasso('telefone')}>
            usar outro telefone
          </button>
        </>
      )}
      <p className="en-regulamento">ao entrar você aceita o regulamento do programa</p>
    </div>
  );
}
